import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const SpeedometerChart = ({ value, maxValue = 100, label, color = '#667eea', unit = '' }) => {
  const percentage = Math.min((value / maxValue) * 100, 100);
  const remainingPercentage = 100 - percentage;

  // Color based on percentage ranges
  const getColor = (percent) => {
    if (percent >= 80) return '#e53e3e'; // Red
    if (percent >= 60) return '#dd6b20'; // Orange
    if (percent >= 40) return '#d69e2e'; // Yellow
    if (percent >= 20) return '#38a169'; // Green
    return '#3182ce'; // Blue
  };

  const gaugeColor = getColor(percentage);

  const data = {
    datasets: [
      {
        data: [percentage, remainingPercentage],
        backgroundColor: [gaugeColor, '#e2e8f0'],
        borderWidth: 0,
        cutout: '75%',
        rotation: -90,
        circumference: 180,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
  };

  return (
    <div className="speedometer-container">
      <div className="speedometer-chart">
        <Doughnut data={data} options={options} />
        <div className="speedometer-center">
          <div className="speedometer-value">
            {value}<span className="unit">{unit}</span>
          </div>
          <div className="speedometer-percentage">{Math.round(percentage)}%</div>
          <div className="speedometer-label">{label}</div>
        </div>
      </div>
    </div>
  );
};

export default SpeedometerChart;
